import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SeatLotteryForm from '../components/SeatLotteryForm';
import LotteryResult from '../components/LotteryResult';
import { SeatAssignment, SeatConfig, SystemSettings } from '../types';
import { getSettings } from '../utils/db';

const LotteryPage: React.FC = () => {
  const navigate = useNavigate();
  const [assignment, setAssignment] = useState<SeatAssignment | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [settings, setSettings] = useState<SystemSettings>({ totalSeats: 30 });
  
  // 席の設定
  const seatConfig: SeatConfig = {
    totalSeats: settings.totalSeats,
    isTableLayout: false // 連番席のため、テーブルレイアウトはfalse
  };
  
  useEffect(() => {
    const loadSettings = async () => {
      try {
        setLoading(true);
        const settingsData = await getSettings();
        setSettings(settingsData);
        setError(null);
      } catch (err) {
        console.error('設定の読み込みに失敗しました:', err);
        setError('設定の読み込みに失敗しました');
      } finally {
        setLoading(false);
      }
    };
    
    loadSettings();
  }, []);
  
  const handleLotteryComplete = (result: SeatAssignment) => {
    setAssignment(result);
  };
  
  const handleReturnHome = () => {
    navigate('/');
  };
  
  return (
    <div className="lottery-page">
      <div className="container">
        <header>
          <h1>席抽選システム</h1>
        </header>
        
        <main>
          {loading ? (
            <div className="loading">読み込み中...</div>
          ) : error ? (
            <div className="error-container">
              <div className="error-message">{error}</div>
              <button onClick={handleReturnHome} className="return-button">
                ホームに戻る
              </button>
            </div>
          ) : !assignment ? (
            <SeatLotteryForm 
              config={seatConfig} 
              onLotteryComplete={handleLotteryComplete} 
            />
          ) : (
            <>
              <LotteryResult 
                assignment={assignment} 
                config={seatConfig} 
              />
              
              <div className="actions">
                <button 
                  onClick={handleReturnHome}
                  className="return-button"
                >
                  ホームに戻る
                </button>
              </div>
            </>
          )}
        </main>
      </div>
    </div>
  );
};

export default LotteryPage; 